const translations = {
    applicationLabel: 'Application',
    assetLabel: 'Asset',
    boundaryLabel: 'Boundary',
    clientLabel: 'Client',
    farmLabel: 'Farm',
    fieldLabel: 'Field',
    importLabel: 'Import',
    memberLabel: 'Member',
    prescriptionLabel: 'Prescription'
};

export default translations;
